// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__1ac8I","messages":"Chat_messages__2uKgI","dateDivider":"Chat_dateDivider__fd7EM"};